import type { MusicListDataItem } from '@/pages/tad.ai/ai-music-generator/_types/trpc'

export function pushMusics(
  originMusics: MusicListDataItem[],
  musics: MusicListDataItem[],
) {
  //后端数据实时更新，新歌曲插入index最前，但前端第一页固定从某个index开始拉取，所以可能滚动过程中有重复
  const musicsIdSet = new Set<string>()
  const uniqMusics = [...originMusics]
  uniqMusics.forEach((music) => {
    musicsIdSet.add(music.uuid)
  })
  musics.forEach((music) => {
    if (!musicsIdSet.has(music.uuid)) {
      uniqMusics.push(music)
    }
  })
  return uniqMusics
}
